import { Button, DropdownMenuItem, SplitButton } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface EmployeeSaveViewButtonProps {
  isDefaultActive: boolean;
  isUpdating: boolean;
  onUpdateView: () => void;
  onSaveAsNewView: () => void;
}

export function EmployeeSaveViewButton({
  isDefaultActive,
  isUpdating,
  onUpdateView,
  onSaveAsNewView,
}: EmployeeSaveViewButtonProps) {
  const { t } = useTranslation();

  if (isDefaultActive) {
    return (
      <Button variant="secondary" onClick={onSaveAsNewView}>
        {t("core:save_view")}...
      </Button>
    );
  }

  return (
    <SplitButton
      variant="secondary"
      isLoading={isUpdating}
      onClick={onUpdateView}
      menuLabel={t("common:more_save_options")}
      menu={
        <DropdownMenuItem
          title={t("core:save_as_new_view")}
          description={t("core:save_current_filters_and_columns")}
          onClick={onSaveAsNewView}
        />
      }
    >
      {t("core:save_view")}
    </SplitButton>
  );
}
